module.exports = __webpack_public_path__ + "static/id4-5eeccdf5b3e13c3327c54da9335de56c.jpg";